import { useState, useEffect, useCallback } from 'react'

function useHamburgerStatus() {
  const [isActive, setIsActive] = useState(false)

  const toggleHamburger = useCallback(() => {
    setIsActive(state => !state)
  }, [])

  useEffect(() => {
    function closeHamburger() {
      document.body.classList.remove('is-overlaid')
      setIsActive(false)
    }

    window.addEventListener('listing-page:navigate-category-mobile', closeHamburger)

    return () => {
      window.removeEventListener('listing-page:navigate-category-mobile', closeHamburger)
    }
  }, [])

  return { isActive, toggleHamburger }
}

export { useHamburgerStatus }
